import { Booking, Schedule, VehicleDowntime } from '@deliveries-app/models';
import { useRouter } from 'next/router';
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
  useRef,
} from 'react';
import toast from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import { getTimePart } from '../../../utils/helpers';
import Body, { Event } from './Body';
import { vehicleService } from '@deliveries-app/services';
import moment from 'moment-timezone';
import { setBookingDate, setLoading } from '../../../store/actionCreators';
import Header from './Header';
import { RootReducerState } from '../../../store/reducer';
import MaintenanceModal from '../../Modals/Maintenance/vehicle';

interface CalendarProps {
  bookings: Booking[];
  updateBooking: (
    branch_id: number,
    booking_id: number,
    vehicle_id: number,
    start_time: string
  ) => Promise<void>;
  updateSchedule: (schedule: Schedule) => Promise<void>;
  fetchSchedule: (day?: string) => Promise<void>;
  schedule: Schedule;
  date: Date;
  setDate: Dispatch<SetStateAction<Date>>;
  create: boolean;
  duration: number | null;
  description: string;
  fetchBookings: () => Promise<void>;
  bookingId?: string | string[];
  duplicate?: string | string[];
}
const Calendar = ({
  bookings,
  updateBooking,
  updateSchedule,
  fetchSchedule,
  schedule,
  date,
  setDate,
  create,
  duration,
  description,
  fetchBookings,
  bookingId,
  duplicate,
}: CalendarProps) => {
  const router = useRouter();
  const branch = useSelector(
    (state: RootReducerState) => state.dashboard.selectedBranch
  );

  const [vehicleTimeResp, setVehicleTimeResp] = useState([]);
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);
  const [draggedBooking, setDraggedBooking] = useState<Event | null>();
  const [openingHours, setOpeningHours] = useState<any>();
  const [scheduleLimit, setScheduleLimit] = useState<number | null>(null);
  const [columns, setColumns] = useState<Event[]>([]);
  const [showing, setShowing] = useState<string>();
  const [showNote, setShowNote] = useState<boolean>(false);
  const [driverList, setDriverList] = useState<any[]>([]);
  const timelineRef = useRef();

  const [maintenanceTime, setMaintenanceTime] = useState([]);
  const [openDatePicker, setOpenDatePicker] = useState<boolean>(false);
  const [showShowMaintenance, setShowMaintenance] = useState<boolean>(false);

  const [startDateMaintenance, setStartDateMaintenance] = useState<Date>(
    new Date()
  );
  const [endDateMaintenance, setEndDateMaintenance] = useState<Date>(
    new Date()
  );

  const [dateMaintenance, setDateMaintenance] = useState<Date>(new Date());
  const [idVehicles, setIdVehicles] = useState<number>(0);
  const [vehicleDowntimeList, setVehicleDowntimeList] = useState<
    VehicleDowntime[]
  >([]);

  const dispatch = useDispatch();
  const handleDragEnter = (event) => {
    event.preventDefault();

    if (event.target.getAttribute('data-index') !== null) {
      // event.target.style.backgroundColor = 'red';
      setHoverIndex(Number(event.target.getAttribute('data-index')));
    }
  };

  /**
   * This function recalculates the columns and the hours
   * It also triggers the API to update the dropped booking
   *
   * @param event DragEvent<HTMLDivElement>
   * @param index number
   */
  const handleDragDrop = (event, index = null) => {
    event.preventDefault();

    if (
      isUnderMaintence(index) ||
      checkBookingBetween(index, draggedBooking.duration)
    ) {
      toast.error('Vehicle Under Maintenance');
      setDraggedBooking(null);
    } else {
      if (!index) {
        index = Number(event.target.getAttribute('data-index'));
      }

      const start_time = Math.floor(index / branch.vehicles.length);

      const updatedBooking = {
        ...draggedBooking,
        vehicle_id: branch.vehicles[index % branch.vehicles.length].id,
        start_time: start_time,
      };

      if (index !== null) {
        setHoverIndex(null);
        setColumns(
          columns.map((booking) => {
            if (booking.id === updatedBooking.id) {
              return updatedBooking;
            }
            return booking;
          })
        );
      }

      updateBooking(
        updatedBooking.branch.id,
        updatedBooking.id,
        updatedBooking.vehicle_id,
        startTime(updatedBooking)
      );

      setDraggedBooking(null);
    }
  };

  const checkBookingBetween = useCallback(
    (index: number, duration: number) => {
      const arr = [];
      const span = Math.ceil(duration / 5);
      for (let i = 0; i < span; i++) {
        arr.push(index + i * branch.vehicles.length);
      }

      const found = maintenanceTime.some((r) => arr.includes(r));

      return found;
    },
    [maintenanceTime]
  );

  /**
   * This is for hovering around the calendar when creating a new booking
   *
   * @param event
   */
  const handleHoverOver = useCallback(
    (event) => {
      event.preventDefault();

      if (create && duration) {
        setHoverIndex(Number(event.target.getAttribute('data-index')));
      }
    },
    [create, duration]
  );
  const handleSlotClick = useCallback(
    (event, index) => {
      event.preventDefault();

      const { unhold, lat, lng, reschedule, id, total_distance, driver_id } =
        router.query;
      const opening = openingHours.hours.opening_time;
      const total = Math.floor(index / branch.vehicles.length) * 5;
      const hours = parseInt(opening.split(':')[0]) + Math.floor(total / 60);
      const minutes = parseInt(opening.split(':')[1]) + (total % 60);
      const result = `${moment(date).format('MM/DD/YYYY')} ${String(
        hours
      ).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
      const vehicle_id = branch.vehicles[index % branch.vehicles.length].id;
      dispatch(setBookingDate(date));
      if (reschedule == 'true' && id != null) {
        const rescheduleTime = `${moment(date).format('yyyy-MM-DD')} ${String(
          hours
        ).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

        // bookingService
        //   .rescheduleBookingById(
        //     id as any,
        //     vehicle_id,
        //     rescheduleTime,
        //     lat as any,
        //     lng as any,
        //     driver_id as any
        //     // branch_id: updatedBooking.branch_id,
        //     // driver_id: updatedBooking.driver_id,
        //     // status: updatedBooking.status,
        //     // duration: updatedBooking.duration,
        //   )
        //   .then((res) => {
        //     toast.success('Data saved');
        //     router.push('/bookings');
        //   })
        //   .catch((err) => {
        //     if (err.response) {
        //       toast.error(err.response.data.booking);
        //     } else {
        //       toast.error('ERROR');
        //     }
        //   });
      } else {
        if (duplicate == 'true') {
          router.push(
            `/bookings/create?start_time=${result}&vehicle_id=${vehicle_id}&total_distance=${total_distance}&lat=${lat}&lng=${lng}`
          );
        } else {
          if (unhold) {
            router.push(
              `/bookings/${bookingId}?start_time=${result}&vehicle_id=${vehicle_id}&total_distance=${total_distance}&lat=${lat}&lng=${lng}&unhold=${unhold}`
            );
          } else if (typeof bookingId !== 'undefined') {
            router.push(
              `/bookings/${bookingId}?start_time=${result}&vehicle_id=${vehicle_id}&total_distance=${total_distance}&lat=${lat}&lng=${lng}`
            );
          } else {
            if (create && duration && !checkBookingBetween(index, duration)) {
              router.push(
                `/bookings/create?start_time=${result}&vehicle_id=${vehicle_id}&total_distance=${total_distance}&lat=${lat}&lng=${lng}`
              );
            } else {
              // isFull(index) || isUnder(index) ? '' : router.push('/bookings/create');
            }
          }
        }
      }

      checkBookingBetween(index, duration);
    },
    [router, create, duration, openingHours, maintenanceTime]
  );

  const handleShowTimeline = (bookingValue: string) => {
    if (showing == bookingValue) {
      setShowing('');
    } else {
      setShowing(bookingValue);
    }
  };

  const isUnderMaintence = useCallback(
    (index: number) => {
      const array = maintenanceTime;
      return array.includes(index);
    },
    [branch, maintenanceTime]
  );

  const startTime = useCallback(
    (booking) => {
      const opening = openingHours.hours.opening_time;
      const total = booking.start_time * 5;
      const hours = parseInt(opening.split(':')[0]) + Math.floor(total / 60);
      const minutes = parseInt(opening.split(':')[1]) + (total % 60);

      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
        2,
        '0'
      )}`;
    },
    [openingHours]
  );

  useEffect(() => {
    const hours = branch.opening_hours.find(
      (o) => o.day === (date.getDay() === 0 ? 7 : date.getDay())
    );

    if (hours) {
      const start = parseInt(hours.opening_time.split(':')[0]) * 12;
      const end = (parseInt(hours.closing_time.split(':')[0]) + 1) * 12;
      const diff = end - start;

      setOpeningHours({ hours, start, end, diff });
    } else {
      setOpeningHours(null);
    }
  }, [branch, description, bookings, date]);

  const makePromiseVehicle = async () => {
    const response = await Promise.all(
      branch.vehicles.map(
        async (vehicle) =>
          await vehicleService
            .getTimeStampBookingStatus(
              branch.id,
              vehicle.id,
              moment(date).format('YYYY-MM-DD')
            )
            .then((res) => ({ id: vehicle.id, result: res }))
            .catch((err) => 0)
      )
    );
    setVehicleTimeResp(response);
  };

  useEffect(() => {
    makePromiseVehicle();
  }, []);

  const filterDriverFromBooking = (list: Booking[]) => {
    const driverFilter = [];

    list.forEach((val: Booking) => {
      if (val.driver) {
        const driverIdentity = {
          id: val.driver ? val.driver.id : null,
          colour: val.colour,
          name: val.driver ? val.driver.name : '',
        };

        const check = driverFilter.find(
          (driver) => driver.id === val.driver.id
        );
        if (!check) {
          driverFilter.push(driverIdentity);
        }
      }
    });
    setDriverList(driverFilter);
  };

  const filterVehicle = () => {
    if (driverList.length > 0) {
      return driverList.map((val, index) => {
        if (val.name) {
          return (
            <div
              key={index}
              className={` flex h-8 w-8 items-center justify-center rounded-full font-medium text-white ${
                index !== driverList.length - 1 && 'mr-2'
              }`}
              style={{ backgroundColor: val.colour }}
            >
              {val.name.charAt(0).toUpperCase()}
            </div>
          );
        }
      });
    } else {
      return <div></div>;
    }
  };

  useEffect(() => {
    if (!openingHours) return;
    const list = bookings
      .filter((booking) => {
        const d1 = new Date(booking.start_time);
        const d2 = date;
        return (
          d1.getFullYear() === d2.getFullYear() &&
          d1.getMonth() === d2.getMonth() &&
          d1.getDate() === d2.getDate()
        );
      })
      .map((booking, index) => {
        const pre =
          (parseInt(getTimePart(booking.start_time).split(':')[0]) -
            parseInt(openingHours.hours.opening_time.split(':')[0])) *
            12 +
          parseInt(getTimePart(booking.start_time).split(':')[1]) / 5;

        const startIndex =
          parseInt(getTimePart(booking.start_time).split(':')[0]) * 12 +
          parseInt(getTimePart(booking.start_time).split(':')[1]) / 5;
        const span = Math.ceil(booking.duration / 5);

        return {
          ...booking,
          start_time: pre,
          booking_id: booking.id,
          span: span,
        };
      });

    filterDriverFromBooking(list as any);
    setColumns(list);
  }, [bookings, openingHours, date]);

  const column = useCallback(
    (id) => branch.vehicles.findIndex((v) => v.id === id),
    [branch.vehicles]
  );

  const row = useCallback(
    (id) => id * branch.vehicles.length,
    [branch.vehicles]
  );

  useEffect(() => {
    dispatch(setLoading(true));
    if (!openingHours) return;
    const vehicleDowntimeArr = [];
    vehicleService
      .getBranchVehicleDowntimes(branch.id, moment(date).format('YYYY-MM-DD'))
      .then((res) => {
        dispatch(setLoading(false));
        const isEmpty = res.every(function (a) {
          return !a.length;
        });
        if (!isEmpty) {
          res.forEach((nested) => {
            nested.forEach((element) => {
              const pre =
                (parseInt(getTimePart(element.start_time).split(':')[0]) -
                  parseInt(openingHours.hours.opening_time.split(':')[0])) *
                  12 +
                parseInt(getTimePart(element.start_time).split(':')[1]) / 5;

              const newPoint = Math.floor(
                column(element.vehicle_id) + row(pre)
              );

              const start = moment(element.start_time).utc();
              const end = moment(element.end_time).utc();
              const diff = end.diff(start, 'minutes') / 5;

              for (let index = 0; index < diff; index++) {
                vehicleDowntimeArr.push(
                  newPoint + index * branch.vehicles.length
                );
              }
            });
          });

          setMaintenanceTime(vehicleDowntimeArr);
        } else {
          setMaintenanceTime([]);
        }
      })
      .catch((err) => console.log(err));
  }, [bookings, branch, date]);

  useEffect(() => {
    if (schedule) {
      setScheduleLimit(schedule.number_of_available_drivers);
    } else {
      setScheduleLimit(0);
    }
  }, [schedule]);

  const setSchedule = (value) => {
    const promise = updateSchedule({
      ...schedule,
      number_of_available_drivers: value ?? 0,
      day: moment(date).tz(branch.timezone).format('YYYY-MM-DD'),
    });
    toast.promise(promise, {
      loading: 'Saving...',
      success: 'Saved!',
      error: 'Error when saving',
    });
  };

  const handleOpenDatePicker = (event) => {
    event.preventDefault();
    setOpenDatePicker((prev) => !prev);
  };

  const showMaintenanceModal = (id: number) => {
    setIdVehicles(id);
    setShowMaintenance(true);
    getVehicleMaintenanceList(id);
  };
  const onVehicleDowntimesSubmit = (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    const dateSelected = moment(dateMaintenance).format('yyyy-MM-DD');
    const startTime = moment(startDateMaintenance).format('HH:mm:ss');
    const endTime = moment(endDateMaintenance).format('HH:mm:ss');

    const vehicleId = idVehicles;
    const startDowtime = dateSelected + ' ' + startTime;
    const endDowntime = dateSelected + ' ' + endTime;

    vehicleService
      .postVehicleDowntime(branch?.id, vehicleId, startDowtime, endDowntime)
      .then((res) => {
        toast.success('Data Saved!');
        setShowMaintenance(false);
        fetchBookings();
      })
      .catch((err) =>
        toast.error(
          err.response.data.errors?.time ?? 'Failed to create vehicle downtime'
        )
      );
  };

  const getVehicleMaintenanceList = async (id: number) => {
    await vehicleService
      .getVehicleDowntime(branch?.id, id, {
        start_time: moment(date).format('YYYY-MM-DD'),
      })
      .then((res) => {
        branch?.vehicles.map((vehicles) => {
          if (vehicles.id === id) {
            const index = branch?.vehicles.indexOf(vehicles);
            setVehicleDowntimeList(res[index]);
          }
        });
      })
      .catch((err) => console.log(err));
  };

  const onDeleteDowntime = (id: number) => {
    vehicleService
      .deleteDowntime(branch?.id, idVehicles, id)
      .then((res) => {
        toast.success('deleted!');
        getVehicleMaintenanceList(idVehicles);
        fetchBookings();
      })
      .catch((err) => toast.error('error when deleting!'));
  };

  if (!(branch && scheduleLimit !== null)) {
    console.log(branch, scheduleLimit);
    return (
      <div className="flex h-full w-full items-center justify-center">
        <p>Loading..</p>
      </div>
    );
  }

  return (
    <div className="z-0">
      <MaintenanceModal
        dateMaintenance={dateMaintenance}
        setShowModal={setShowMaintenance}
        startDate={startDateMaintenance}
        endDate={endDateMaintenance}
        setDateMaintenance={setDateMaintenance}
        downtimeList={vehicleDowntimeList}
        onDowntimeSubmit={onVehicleDowntimesSubmit}
        onDeleteDowntime={onDeleteDowntime}
        setEndDate={setEndDateMaintenance}
        setStartDate={setStartDateMaintenance}
        isShow={showShowMaintenance}
      />

      <Header
        date={date}
        scheduleLimit={scheduleLimit}
        setSchedule={setSchedule}
        setDate={setDate}
        fetchSchedule={fetchSchedule}
        showNote={showNote}
        setShowNote={setShowNote}
        fetchBookings={fetchBookings}
        handleOpenDatePicker={handleOpenDatePicker}
        setOpenDatePicker={setOpenDatePicker}
        openDatePicker={openDatePicker}
      />
      <div className="mt-16 flex flex-row justify-end pr-10">
        {filterVehicle()}
      </div>
      <div className="flex pl-20">
        <Body
          columns={columns}
          handleDragEnter={handleDragEnter}
          handleDragDrop={handleDragDrop}
          handleHoverOver={handleHoverOver}
          handleSlotClick={handleSlotClick}
          openingHours={openingHours}
          hoverIndex={hoverIndex}
          scheduleLimit={scheduleLimit}
          draggedBooking={draggedBooking}
          setDraggedBooking={setDraggedBooking}
          create={create}
          duration={duration}
          showing={showing}
          handleShowingTimeline={handleShowTimeline}
          timelineRef={timelineRef}
          vehicleTime={vehicleTimeResp}
          fetchBookings={fetchBookings}
          isUnderMaintenance={isUnderMaintence}
          showMaintenanceModal={showMaintenanceModal}
        />
      </div>
    </div>
  );
};

export default Calendar;
